export const NOTIFY_ADD = "NOTIFY_ADD";
export const NOTIFY_CLEAR = "NOTIFY_CLEAR";

export function addNotify(data) {
    return { type: NOTIFY_ADD, data }
};

export function clearNotify() {
    return { type: NOTIFY_CLEAR }
};



// WEBPACK FOOTER //
// ./src/services/store/reducers/notify/actions.js